<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  methods:{
    ...mapActions(["transferPoint", "checkPosterAvailablePointSum"]),
    checkFunds(itemPoints){
      return (this.myPointsSum >= itemPoints)
    },
    formatPoints(value) {
      if(!value){
        return 0;
      }
      let points = (value).toLocaleString('en-US', {
        currency: 'USD',
      });
      return points;
    }
  },
  computed:{
    ...mapGetters({
      myPointsSum: "getMyPointSum"
    })
  }
}
</script>
